import { storeContacts, storeRequest, storeSteps, storeTasks } from '@/store/case'
import { RequestContacts } from '@/types/api/polygon-employee'
import { Step } from '@/types/api/steps'
import { Tasks } from '@/types/api/task'
import { apiRequest } from './http-service'

async function loadRequest() {
  const request = apiRequest<Request>('GET', 'request', { cancellationId: 'request' }).then(storeRequest)
  const tasks = apiRequest<Tasks>('GET', 'request/tasks', { cancellationId: 'tasks' }).then(storeTasks)
  const steps = apiRequest<Step[]>('GET', 'request/steps', { cancellationId: 'steps' }).then(storeSteps)
  const contacts = apiRequest<RequestContacts>('GET', 'request/contacts', { cancellationId: 'contacts' }).then(storeContacts)

  return Promise.all([request, tasks, contacts, steps])
}

export { loadRequest }
